<template>
    <div class="p-5 flex flex-col text-expressgray">
      <div class="flex flex-col border border-gray-100 shadow-sm bg-white p-5 rounded-lg">
        <h2 class="w-full font-semibold text-express text-xl">Journey Plan</h2>
        <div class="flex flex-col sm:flex-row flex-wrap gap-6 sm:justify-between mt-4">
          <div class="flex flex-col space-y-2">
            <h2 class="text-sm text-expressgray">Personnel Name</h2>
            <h3 class="text-sm font-medium text-gray-900">Ogunleye Seye</h3>
          </div>

          <div class="flex flex-col space-y-2">
            <h2  class="text-sm text-expressgray">Phone</h2>
            <h3 class="text-sm font-medium text-gray-900">08145682628</h3>
          </div>

          <div class="flex flex-col space-y-2">
            <h2  class="text-sm text-expressgray">Email</h2>
            <h3 class="text-sm font-medium text-gray-900">ogunleye.seye@tizeti.com</h3>
          </div>

          <div class="flex flex-col space-y-2">
            <h2  class="text-sm text-expressgray">Created</h2>
            <h3 class="text-sm font-medium text-gray-900">January 16, 2022</h3>
          </div>

        </div>
      </div>


      <div class="w-full bg-white border border-gray-100 shadow-sm rounded-lg p-5 mt-3 flex flex-col md:flex-row">
          <div class="w-full md:w-4/5 p-3 flex flex-col">
              <div class="h-10 w-full flex  justify-between items-center">
                <div class="flex space-x-4 items-center">
                    <h3 class="text-sm font-medium text-gray-900">Week 3</h3>
                  <i class="fas fa-angle-left px-4 py-2 border border-gray-200 rounded-lg cursor-pointer hover:bg-express hover:text-white hover:border-express transition-colors"></i>
                  <i class="fas fa-angle-right px-4 py-2 border border-gray-200 rounded-lg cursor-pointer hover:bg-express hover:text-white hover:border-express transition-colors"></i>
                </div>
                <h3 class="text-sm text-express font-medium">Jan 17  - Jan 22</h3>
              </div>



            <div class="grid grid-cols-5 gap-0 mt-4">
              <div class="bg-inboxbg p-5 border-l-4 border-r-2">Monday</div>
              <div class="bg-inboxbg p-5 border-l-2 border-r-2">Tuesday</div>
              <div class="bg-inboxbg p-5 border-l-2 border-r-2">Wednesday</div>
              <div class="bg-inboxbg p-5 border-l-2 border-r-2">Thursday</div>
              <div class="bg-inboxbg p-5 border-l-2 border-r-4">Friday</div>

              <div class="flex flex-col space-y-3 p-3 border-l-4 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo road, Oworoshoki, Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Nduvins Nig. Enterprises-1</h3>
                <p>40 Oworo road, Oworoshoki, Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Standonventure</h3>
                <p>3b fakoya street, akowonjo, egbeda</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>A-B-D-Communication-2</h3>
                <p>68, Iyana ipaja road alaguntan bus stop, iyaja ipaja,</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-4 border-b-2">
                <h3>Try and See Technologies</h3>
                <p>12 buluro street aluminum village dopemu Agege</p>
              </div>


              <div class="flex flex-col space-y-3 p-3 border-l-4 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-4 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>



              <div class="flex flex-col space-y-3 p-3 border-l-4 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-4 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>




              <div class="flex flex-col space-y-3 p-3 border-l-4 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-2 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>

              <div class="flex flex-col space-y-3 p-3 border-l-2 border-r-4 border-b-2">
                <h3>Top Most Media Concept</h3>
                <p>40 Oworo Rd, Oworoshoki,Bariga</p>
              </div>





            </div>


           </div>
        <div class="w-full md:w-1/5 p-3 flex flex-row md:flex-col items-center justify-center gap-4 md:space-y-4 mt-4 md:mt-0">
          <div class="flex flex-col items-center text-center rounded-lg p-4 text-express hover:bg-gray-50 text-sm cursor-pointer transition-colors">
            <i class="fas fa-edit"></i>
            <h3 class="mt-1">Edit</h3>
          </div>

          <div class="flex flex-col items-center text-center rounded-lg p-4 text-express hover:bg-gray-50 text-sm cursor-pointer transition-colors">
            <i class="fas fa-cloud-download-alt"></i>
            <h3 class="mt-1">Download</h3>
          </div>



        </div>




      </div>


    </div>
</template>

<script>
export default {
  name: "IndividualJourneyPlan"
}
</script>

<style scoped>

</style>
